<span class="iu-input-text-ui" [style.backgroundColor]="backgroundColorCss" [style.display]="displayCss">
  <p style="font-size: 14px; margin: 5px" [innerHTML]="fieldValue | safeHtml"></p>
</span>
